import { c as _c } from "react/compiler-runtime";
import type { ReactElement, ReactNode } from 'react';
import { cn } from '#cn';
type NoticePillProps = {
  icon: ReactElement;
  children: ReactNode;
  className?: string;
};

/**
 * A compact rounded pill with a leading icon and short text for at-a-glance
 * notices (e.g. the trial-status banner). It carries its own light surface and
 * border, so it reads on both light and dark backgrounds without restyling.
 *
 * The icon is purely decorative, so the pill wraps it `aria-hidden` and owns
 * its size/stroke weight — callers pass a bare icon (`<Sparkles />`) and can't
 * drift on hiding it (lucide icons aren't hidden by default) or on its
 * dimensions.
 */
export const NoticePill = t0 => {
  const $ = _c(8);
  const {
    icon,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center gap-3 rounded-full border border-border bg-surface px-4 py-2 text-sm font-medium text-fg shadow-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = <span aria-hidden={true} className="contents [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:[stroke-width:1.5]">{icon}</span>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};